require('normalize.css/normalize.css');
require('animate.css/animate.min.css');
require('styles/App.css');

import React from 'react';
import * as TotemActions from '../actions/TotemActions';
import TotemStore from '../stores/TotemStore';

var headerLogo = require('../images/headerLogo.png');

class ConfigurationComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            categoryId: 1,
            brandId: 1,
            categories: TotemActions.getCategories(),
            brands: TotemActions.getBrands()
        };
    }

    componentWillMount() {
        TotemStore.on('CATEGORIES_RECEIVED', this._onReceiveCategories.bind(this));
        TotemStore.on('BRANDS_RECEIVED', this._onReceiveBrands.bind(this));
    }

    _onReceiveCategories() {
        this.setState({
            categories: TotemStore.getCategories()
        });
    }
    _onReceiveBrands() {
        this.setState({
            brands: TotemStore.getBrands()
        });
    }

    _handleInputChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    _navigateToApplication() {
        this.props.history.push('/' + this.state.categoryId + '/' + this.state.brandId);
    }

    render() {

        let { categories } = this.state;

        let categoriesOptions = [];

        if (categories) {
            categoriesOptions = categories.map((category) => {
                return <option value={category.id} key={category.id}>{category.name}</option>
            });
        }

        let { brands } = this.state;

        let brandsOptions = [];

        if (brands) {
            brandsOptions = brands.map((brand) => {
                return <option value={brand.id} key={brand.id}>{brand.name}</option>
            });
        }

        return (
            <div className="loading">
                <div className="spinner">
                    <img className="header-logo" src={headerLogo} />
                </div>
                <div className="center-align">
                    <div className="configuration-title left-align">
                        <span>Filtre los tipos de productos que quiere que se muestren en el Totem.</span>
                    </div>
                    <div className="initial-configuration-block left-align">
                        <div className="configuration-option">
                            <span>Sucursal:</span>
                            <select className="browser-default" name="brandId" value={this.state.brandId} onChange={this._handleInputChange.bind(this)}>
                                {brandsOptions}
                            </select>
                        </div>
                        <div className="configuration-option">
                            <span>Categoría:</span>
                            <select className="browser-default" name="categoryId" value={this.state.categoryId} onChange={this._handleInputChange.bind(this)}>
                                {categoriesOptions}
                            </select>
                        </div>
                    </div>
                    <div className="continue-button">
                        <a className="waves-effect waves-light btn blue darken-4" onClick={this._navigateToApplication.bind(this)}>Continuar</a>
                    </div>
                </div>
            </div>
        );
    }
}



ConfigurationComponent.defaultProps = {
};

export default ConfigurationComponent;



// WEBPACK FOOTER //
// ./src/components/Configuration.js